import { axiosInstance } from "./axios";
import { API_URL_STORES } from "@/services/XCONS_ENV";

/**
 * El `storeId` (Magento) de un store por su código, para el alta de un presupuesto.
 *
 * `GET /stores` sin flags contesta **qué stores administra** este operador, no **dónde opera**. Un
 * operador de seller no administra ningún store —opera en los que su seller está linkeado y
 * activo—, así que la lista le volvía vacía y el "+" de Presupuestos de la ficha de contacto y de
 * Conversaciones cortaba con "No se pudo resolver el store" antes de llegar al `POST /quotes`, que
 * sí lo acepta. `includeSellerLinked=true` es la pregunta correcta; ver `useOperatorStores`.
 *
 * Se pide **ese** store y no la lista entera: la lista viene paginada y un store que cayera fuera
 * de la primera página daría el mismo error.
 */
export async function resolveStoreId(storeCode: string): Promise<number | undefined> {
  const code = storeCode.trim();
  if (!code) return undefined;
  const { data } = await axiosInstance.get(API_URL_STORES, {
    params: { includeSellerLinked: true, "filter.code": `$eq:${code}` },
  });
  const rows: any[] = data?.data ?? [];
  const store = rows.find((s) => String(s?.code ?? "").trim() === code);
  return store?.store_id ?? store?.storeId;
}
